import { useEffect, useRef, useState } from "react";

const ADJECTIVES = [
  "Listening",
  "Questioning",
  "Reflecting",
  "Supporting",
  "Challenging",
  "Emboldening",
  "Stretching",
  "Affirming",
];

const WORDS = [...ADJECTIVES, ...ADJECTIVES];

export const AdjectiveRibbon = () => {
  const wordRefs = useRef([]);
  const [active, setActive] = useState(-1);

  useEffect(() => {
    let raf;
    const tick = () => {
      const center = window.innerWidth / 2;
      let best = -1;
      let bestDist = Infinity;
      wordRefs.current.forEach((el, i) => {
        if (!el) return;
        const r = el.getBoundingClientRect();
        const d = Math.abs(r.left + r.width / 2 - center);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      });
      setActive((prev) => (prev === best ? prev : best));
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div
      className="bg-windsor py-6 overflow-hidden marquee-mask select-none"
      data-testid="adjective-ribbon"
      aria-label="Listening, questioning, reflecting, supporting, challenging, emboldening, stretching, affirming"
    >
      <div
        className="flex w-max animate-marquee whitespace-nowrap hover:[animation-play-state:paused]"
        style={{ animationDuration: "44s" }}
      >
        {WORDS.map((word, i) => (
          <span key={i} className="flex items-center">
            <span
              ref={(el) => (wordRefs.current[i] = el)}
              className={`font-serif italic text-3xl md:text-4xl px-8 transition-all duration-300 ${
                active === i
                  ? "text-gold scale-110 not-italic font-medium"
                  : "text-ivory/80"
              }`}
            >
              {word}
            </span>
            <span className="text-ivory/40 text-2xl">&bull;</span>
          </span>
        ))}
      </div>
    </div>
  );
};
